import PropTypes from 'prop-types';
import {  useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
import ApexCharts from 'apexcharts';
import Chart from 'react-apexcharts';
import MainCard from '../MainCard';
import { gridSpacing } from '../../../store/constant';


const LineChart = ({ isLoading, categories, title, decimal, series, lineWidth, lineDash, title2, series2, series2G, categories2G, title2G, series2G2, title2G2 }) => {
    const theme = useTheme();
    const { primary } = theme.palette.text;
    const grey200 = "#eeeeee";
    const grey500 = "#9e9e9e";
    const primary200 = "#90caf9";
    const primaryDark = "#1e88e5";
    const secondaryMain = "#673ab7";
    const secondaryLight = "#ede7f6";

    const lineChartData = {
        height: 480,
        options: {
            chart: {
                type: 'line',
                id: 'line-chart',
                toolbar: {
                    show: false
                },
            },
            xaxis: {
                type: 'category',
                categories: categories
            },
            yaxis: [
              {
                labels: {
                  formatter: function(val) {
                    return val.toFixed(decimal);
                  }
                }
              }
            ],
            stroke: {
                width: lineWidth,
                curve: 'smooth',
                dashArray: lineDash,
            },
            title: {
                text: title,
                align: 'left'
            },
            colors: ['#60ABD2','#3d85c6','#0b5394']
        },
        series: series,
    };

    const lineChartData2 = {
        height: 480,
        options: {
            chart: {
                type: 'line',
                id: 'line-chart',
                toolbar: {
                    show: false
                },
            },
            xaxis: {
                type: 'category',
                categories: categories
            },
            yaxis: [
              {
                labels: {
                  formatter: function(val) {
                    return val.toFixed(decimal);
                  }
                }
              }
            ],
            stroke: {
                width: lineWidth,
                curve: 'smooth',
                dashArray: lineDash,
            },
            title: {
                text: title2,
                align: 'left'
            },
            colors: ['#60ABD2','#3d85c6','#0b5394']
        },
        series: series2,
    };

    const cats2G = categories2G && categories2G.length > 0 ? categories2G : categories;

    const lineChartData2G = {
        height: 480,
        options: {
            chart: {
                type: 'line',
                id: 'line-chart-2g',
                toolbar: {
                    show: false
                },
            },
            xaxis: {
                type: 'category',
                categories: cats2G
            },
            yaxis: [
              {
                labels: {
                  formatter: function(val) {
                    return val.toFixed(decimal);
                  }
                }
              }
            ],
            stroke: {
                width: lineWidth,
                curve: 'smooth',
                dashArray: lineDash,
            },
            title: {
                text: title2G || '2G',
                align: 'left'
            },
            colors: ['#e57373','#ef5350','#b71c1c']
        },
        series: series2G,
    };

    const lineChartData2G2 = {
        height: 480,
        options: {
            chart: {
                type: 'line',
                id: 'line-chart-2g2',
                toolbar: {
                    show: false
                },
            },
            xaxis: {
                type: 'category',
                categories: cats2G
            },
            yaxis: [
              {
                labels: {
                  formatter: function(val) {
                    return val.toFixed(decimal);
                  }
                }
              }
            ],
            stroke: {
                width: lineWidth,
                curve: 'smooth',
                dashArray: lineDash,
            },
            title: {
                text: title2G2 || '2G (2)',
                align: 'left'
            },
            colors: ['#e57373','#ef5350','#b71c1c']
        },
        series: series2G2,
    };

    useEffect(() => {
        const newChartData = {...lineChartData.series,};
        const newChartData2 = {...lineChartData2.series,};
        const newChartData2G = {...lineChartData2G.series,};
        const newChartData2G2 = {...lineChartData2G2.series,};
            if (categories !== null){
                      if (!isLoading && categories !== null && categories.length > 0) {
                ApexCharts.exec(`line-chart`, 'updateOptions', newChartData);
            }
            if (!isLoading && lineChartData2.series !== null && categories.length > 0) {
                ApexCharts.exec(`line-chart`, 'updateOptions', newChartData2);
            }
            if (!isLoading && lineChartData2G.series !== null && categories.length > 0) {
                ApexCharts.exec(`line-chart-2g`, 'updateOptions', newChartData2G);
            }
            if (!isLoading && lineChartData2G2.series !== null && categories.length > 0) {
                ApexCharts.exec(`line-chart-2g2`, 'updateOptions', newChartData2G2);
            }
        }

    }, [ primary200, primaryDark, secondaryMain, secondaryLight, primary, grey200, isLoading, grey500, lineChartData.series, categories, lineChartData2.series, lineChartData2G.series, lineChartData2G2.series]);

    const hasData = (s) => s && s.length > 0 && s.some(item => item.data && item.data.length > 0);
    const hasAnyData = hasData(series) || hasData(series2) || hasData(series2G) || hasData(series2G2);

    return (
        <>
            {hasAnyData && (
                <MainCard>
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={12}>
                            <Grid container alignItems="center" justifyContent="space-between">
                                <Grid item>
                                    <Grid container direction="column" spacing={1}>
                                        <Grid item>
                                            <Typography variant="h6" sx={{fontFamily: '"Roboto", "sans-serif"', color: "#406599"}}>Performance</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        { hasData(series)  && (<Grid item xs={12}><Chart {...lineChartData} /></Grid>)}
                        { hasData(series2) && (<Grid item xs={12}><Chart {...lineChartData2} /></Grid>)}
                        { hasData(series2G)  && (<Grid item xs={12}><Chart {...lineChartData2G} /></Grid>)}
                        { hasData(series2G2) && (<Grid item xs={12}><Chart {...lineChartData2G2} /></Grid>)}
                    </Grid>
                </MainCard>
            )}
        </>
    );
};

LineChart.propTypes = {
    isLoading: PropTypes.bool
};

LineChart.defaultProps = {
  lineWidth: [7, 3, 3],
  lineDash: [0, 10, 10],
  series2G: [],
  series2G2: [],
  categories2G: [],
  title2G: '',
  title2G2: '',
};


export default LineChart;
